/**
 * Filter function used to filter out values in object
 * Params:
 * object - object to filter
 * value - value to search within object
 */

(function() {
    'use strict';

    angular.module('app').filter('findAllValueFilter', function() {
        return function (object, value) {
            var filteredObject = {};
            for (var key in object) {
                if (object[key] === value) {
                    filteredObject[key] = value;
                }
                for (var valueKey in object[key]) {
                    if (object[key][valueKey] === value) {
                        filteredObject[valueKey] = value;
                    }
                }
            }
            return filteredObject;
        };
    });

}());